import { render, staticRenderFns } from "./SmCardTaskStates.vue?vue&type=template&id=2de8c8b4&scoped=true&"
import script from "./SmCardTaskStates.vue?vue&type=script&lang=ts&"
export * from "./SmCardTaskStates.vue?vue&type=script&lang=ts&"
import style0 from "./SmCardTaskStates.vue?vue&type=style&index=0&id=2de8c8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8c8b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
